<template>
  <div
    class="arztsuche_formwrapper"
    id="arztsuche_formwrapper"
    :class="{ loading: loadingForm }"
  >
    <form class="arztsuche_form" @submit.prevent="searchSubmit(false)">
      <input
        id="firstname"
        v-model="firstname_hp"
        tabindex="-1"
        style="position: absolute; margin: 0 0 0 -999em"
      />

      <div class="form_line wonach_line">
        <h4>Wonach suchen Sie?</h4>
        <div class="switch_line">
          <InputSwitch :modelValue="!searchForPsycho" />
          <span class="switch_label" @click="searchForPsycho = false"
            >Ärzt:innen</span
          >
        </div>
        <div class="switch_line">
          <InputSwitch v-model="searchForPsycho" />
          <span class="switch_label" @click="searchForPsycho = true"
            >Psychotherapeut:innen u. Ärzt:innen mit psychoth. Leistungen</span
          >
        </div>
        <hr />
      </div>

      <div class="form_line" v-if="searchForPsycho">
        <label for="altersgruppe">Altersgruppe</label>
        <div class="switch_line">
          <span class="switch_label" @click="ptaCheck = false">Erwachsene</span>
          <InputSwitch v-model="ptaCheck" />
          <span class="switch_label" @click="ptaCheck = true"
            >Kinder/Jugendliche</span
          >
        </div>
      </div>

      <OrtSuche
        @loc-changed="updateLoc"
        @update-can-search="updateCanSearch"
        :clear="clear"
      />

      <div class="form_line" v-if="!searchForPsycho">
        <Select
          v-model="fields.fach"
          :input="fields.fach"
          placeholder="Alle"
          label="Fachrichtungen"
          csvFile="fachrichtungen_aerzte"
          :filter="true"
          :showClear="true"
          @load-change="selectLoadChange"
          loadVar="fach"
          :preselect="preselectFach"
        />
      </div>

      <div class="form_line" v-if="searchForPsycho">
        <Select
          v-model="fields.fach"
          :input="fields.fach"
          placeholder="Alle"
          label="Fachrichtungen"
          csvFile="fachrichtungen_psycho"
          :filter="true"
          :showClear="true"
          @load-change="selectLoadChange"
          loadVar="fachp"
        />
      </div>

      <div class="form_line" v-if="searchForPsycho">
        <Select
          v-model="fields.ptv"
          :input="fields.ptv"
          label="Psychotherapieverfahren"
          :optionsIn="ptvoptions"
          :showClear="true"
          placeholder="Bitte Auswählen"
        />
      </div>

      <div class="form_line" v-if="searchForPsycho">
        <Select
          v-model="fields.pts"
          :input="fields.pts"
          label="Setting Psychotherapie"
          :optionsIn="ptsoptions"
          :showClear="true"
          placeholder="Bitte Auswählen"
        />
      </div>

      <div class="form_line">
        <Select
          v-model="fields.umkreis"
          :input="fields.umkreis"
          label="Umkreis"
          csvFile="umkreis"
          :selectFirst="true"
          :clear="clear"
          @load-change="selectLoadChange"
          loadVar="umkreis"
        />
      </div>

      <div class="form_line togglebut_line" v-if="!searchForPsycho">
        <ToggleButton
          v-model="nowopen"
          onIcon="pi pi-check"
          offIcon="pi pi-times"
          id="nowopen"
          @change="nowopenChangeHandler"
          @load-change="selectLoadChange"
        />
        <label for="nowopen" @click="nowopenLabelClick">Jetzt geöffnet</label>
      </div>

      <Button label="Zurücksetzen" id="resetBut" @click.prevent="resetForm" />
      <Button
        label="Suchen"
        id="submitBut"
        @click.prevent="searchSubmit"
        :disabled="!canSearch"
      />
      <hr />

      <Accordion expandIcon="pi pi-fw pi-caret-right">
        <AccordionTab header="weitere Suchkriterien">
          <div class="form_line">
            <label for="nachname">Wen</label>
            <span class="p-input-icon-right">
              <Clearer v-model="fields.nachname" />
              <InputText
                v-model="fields.nachname"
                id="nachname"
                type="text"
                placeholder="Nachname"
              />
            </span>
          </div>

          <div class="form_line" v-if="!searchForPsycho">
            <label for="spDatum"
              >Sprechstunde
              <a
                v-if="szLinkOut"
                :href="szLinkOut"
                target="_blank"
                class="infolink"
              >
                ?</a
              >
            </label>
            <span class="p-input-icon-right">
              <Calendar v-model="fields.spDatum" id="spDatum" />
              <Clearer v-model="fields.spDatum" />
            </span>
          </div>

          <div
            class="form_line hours_line"
            :class="{ disabled: !fields.spDatum }"
            v-if="!searchForPsycho"
          >
            <div class="time_line">
              <label for="spVon">Von</label>
              <span class="p-input-icon-right">
                <Calendar
                  v-model="fields.spVon"
                  id="spVon"
                  :showTime="true"
                  :timeOnly="true"
                  :disabled="!fields.spDatum"
                  hourFormat="24"
                />
                <Clearer v-model="fields.spVon" />
              </span>
            </div>

            <div class="time_line">
              <label for="spBis">Bis</label>
              <span class="p-input-icon-right">
                <Calendar
                  v-model="fields.spBis"
                  id="spBis"
                  :showTime="true"
                  :timeOnly="true"
                  :disabled="!fields.spDatum"
                  hourFormat="24"
                />
                <Clearer v-model="fields.spBis" />
              </span>
            </div>
          </div>

          <div class="form_line" v-if="!searchForPsycho">
            <Select
              v-model="fields.zb"
              :input="fields.zb"
              placeholder="Bitte Auswählen"
              label="Ärztliche Zusatzbezeichnungen *"
              csvFile="zusatzbezeichnungen"
              :filter="true"
              :showClear="true"
              @load-change="selectLoadChange"
              loadVar="zb"
            />
          </div>

          <div class="form_line" v-if="searchForPsycho">
            <Select
              v-model="fields.zb"
              :input="fields.zb"
              placeholder="Bitte Auswählen"
              label="Ärztliche Zusatzbezeichnungen *"
              csvFile="zusatzbezeichnungen_psycho"
              :filter="true"
              :showClear="true"
              @load-change="selectLoadChange"
              loadVar="zbp"
            />
          </div>

          <div class="form_line">
            <Select
              v-model="fields.bf"
              :input="fields.bf"
              placeholder="Bitte Auswählen"
              label="Barrierefreiheit"
              csvFile="barriere"
              :filter="true"
              :infolink="bfLinkOut"
              :showClear="true"
              @load-change="selectLoadChange"
              loadVar="bf"
            />
          </div>

          <div class="form_line">
            <Select
              v-model="fields.S"
              :input="fields.S"
              label="Geschlecht des Arztes"
              :optionsIn="geschlechtoptions"
              :selectFirst="true"
              :clear="clear"
            />
          </div>

          <div class="form_line">
            <Select
              v-model="fields.fs"
              :input="fields.fs"
              placeholder="Bitte Auswählen"
              label="Fremdsprachen**"
              csvFile="fremdsprachen"
              :filter="true"
              :showClear="true"
              @load-change="selectLoadChange"
              loadVar="fs"
            />
            <p class="comment fscomment">
              * Die Suche nach ärztlichen Zusatzbezeichnungen funktioniert nicht
              in Verbindung mit der Suche nach psychologischen
              Psychotherapeut:innen. <br /><br />
              ** Diese Informationen beruhen auf Selbstauskünften und
              gewährleisten keine Behandlung und Diagnose in der Fremdsprache.
            </p>
          </div>
          <div
            v-if="!searchForPsycho"
            v-html="textUnderFormOut"
            class="textunderform"
          ></div>
        </AccordionTab>
      </Accordion>
    </form>
  </div>
</template>

<script>
import Select from "@/components/Select.vue";
import OrtSuche from "@/components/OrtSuche";
import Clearer from "@/components/Clearer";
import Accordion from "primevue/accordion";
import AccordionTab from "primevue/accordiontab";
import Calendar from "primevue/calendar";
import InputText from "primevue/inputtext";
import ToggleButton from "primevue/togglebutton";
import Button from "primevue/button";
import InputSwitch from "primevue/inputswitch";

import getLocs from "@/composables/getLocs";
import parseFieldsToSearchUrl from "@/composables/parseFieldsToSearchUrl";
import appConf from "@/config/config";
import debugLog from "@/composables/debugLog";

import { ref, watchEffect, watch, onUpdated } from "vue";

Date.prototype.withoutTime = function () {
  var d = new Date(this);
  d.setHours(0, 0, 0, 0);
  return d;
};

export default {
  components: {
    Select,
    Accordion,
    AccordionTab,
    Calendar,
    InputText,
    ToggleButton,
    Button,
    InputSwitch,
    Clearer,
    OrtSuche,
  },
  emits: ["selectLoc", "load-change", "update-contentloading", "update-locs"],
   props: [
   "callPdfSearch"
  ],
  setup(props, { emit }) {
    const fields = ref({
      loc: null,
      fach: null,
      umkreis: null,
      nachname: null,
      spDatum: null,
      spVon: null,
      spBis: null,
      zb: null,
      bf: null,
      S: null,
      fs: null,
      pta: null,
      ptv: null,
      pts: null,
    });

    const loading = ref({
      fach: true,
      umkreis: true,
      zb: true,
      bf: true,
      fs: true,
      zbp: true,
      fachp: true,
    });
    const clear = ref(0);
    const nowopen = ref(false);
    const firstname_hp = ref(false);
    const searchForPsycho = ref(false);
    const searchForAerzte = ref(true);
    const ptaCheck = ref(false);
    const preselectFach = ref(true);
    const szLinkOut = ref(szLink);
    const bfLinkOut = ref(bfLink);
    const textUnderFormOut = ref(textUnderForm);
    let preselectLoaded = false;
    const canSearch = ref(true);
    const loadingForm = ref(false);

    const geschlechtoptions = ref([
      { 0: false, name: "egal" },
      { 0: "F", name: "weiblich" },
      { 0: "M", name: "männlich" },
    ]);

    const ptvoptions = ref([
      { 0: "T", name: "Tiefenpsychologisch fundierte Psychotherapie" },
      { 0: "A", name: "Analytische Psychotherapie" },
      { 0: "V", name: "Verhaltenstherapie" },
      { 0: "S", name: "Systemische Therapie" },
    ]);

    const ptsoptions = ref([
      { 0: "G", name: "Gruppentherapie" },
      { 0: "E", name: "Einzeltherapie" },
    ]);

    const nowopenChangeHandler = () => {
      if (nowopen.value) {
        fields.value.spDatum = new Date();
        fields.value.spVon = new Date();
        let totimeValue = new Date();
        totimeValue.setMinutes(totimeValue.getMinutes() + 30);
        fields.value.spBis = totimeValue;
      }
    };

    const nowopenLabelClick = () => {
      nowopen.value = !nowopen.value;
      nowopenChangeHandler();
    };

    const updateLoc = (newloc) => {
      fields.value.loc = newloc;
    };

    const updateCanSearch = (canSearchIn) => {
      canSearch.value = canSearchIn;
    };

    const selectLoadChange = (loadVar, loadStat) => {
      loading.value[loadVar] = loadStat;

      let isLoading = false;
      for (const [key, value] of Object.entries(loading.value)) {
        if (value) {
          isLoading = true;
        }
      }
      emit("load-change", loading);
    };

    const { loadLocs } = getLocs();

    const searchSubmit = async (event, toPdf = false) => {
      // Honeypot
      if (firstname_hp.value) return;
      emit("update-contentloading", true);
      loadingForm.value = true;

      //Tracking
      if (typeof _paq !== "undefined") {
        _paq.push([
          "trackEvent",
          "Arztsucheaaa",
          "Klick auf Arztsuche suchen",
          "ArztsucheKlickSuchenaaa",
        ]);
      }
      //Call and return
      let { urlCall, pdfCall, queryParams } = parseFieldsToSearchUrl(fields.value);

      if (urlCall && !toPdf) {
        loadLocs(urlCall, queryParams).then((data) => {
          emit("update-locs", data);
          loadingForm.value = false;
        });
      }
  
      if(pdfCall && toPdf){
        pdfSend(pdfCall, queryParams);
        loadingForm.value = false;
      }
    };

    const pdfSend = (pdfCall, params ) => {
        var form = document.createElement("form");
    form.target = "_blank";
    form.method = "POST";
    form.action = pdfCall;
    const id = Date.now()+"form";
    form.id = id;
    for (var i in params) {
        if (params.hasOwnProperty(i)) {
          var input = document.createElement('input');
          input.type = 'hidden';
          input.name = i;
          input.value = params[i];
          form.appendChild(input);
        }
    }
    document.body.appendChild(form);
   
    form.submit();
    setTimeout(function(){
      document.getElementById(id).remove();
    }, 300)
    }

    // Reset Form Action
    const resetForm = () => {
      fields.value = {
        ...fields.value,
        fach: null,
        nachname: null,
        spDatum: null,
        spVon: null,
        spBis: null,
        zb: null,
        bf: null,
        fs: null,
        ptv: null,
        pts: null,
      };
      clear.value++;
      ptaCheck.value = false;
    };

    // trigger pdfSearch on prop change
     watch(
      () => props.callPdfSearch,
      (val, prevVal) => {
        if(val !== prevVal){
         searchSubmit(null, true);
        }
      }
    );

    // Update endtime if starttime after endtime
    watch(
      () => fields.value.spVon,
      (currentValue, oldValue) => {
        if (fields.value.spVon > fields.value.spBis) {
          fields.value.spBis = fields.value.spVon;
        }
      }
    );

    // Update starttime if endtime before starttime
    watch(
      () => fields.value.spBis,
      (currentValue, oldValue) => {
        if (fields.value.spBis < fields.value.spVon) {
          fields.value.spVon = fields.value.spBis;
        }
      }
    );

    // Empty fields if search type changed
    watch(
      () => searchForPsycho.value,
      (currentValue, oldValue) => {
        if (currentValue !== oldValue) {
          resetForm();
          if (!currentValue) {
            fields.value.pta = null;
          }
        }
      }
    );

    watchEffect(() => {
      // Update nowopen If Now Open
      let now = new Date();
      if (
        fields.value.spDatum &&
        +fields.value.spDatum.withoutTime() == +now.withoutTime() &&
        fields.value.spVon &&
        +fields.value.spVon.getTime() <= +now.getTime() &&
        fields.value.spBis &&
        +fields.value.spBis.getTime() >= +now.getTime()
      ) {
        nowopen.value = true;
      } else {
        nowopen.value = false;
      }

      // Disable fromtime and totime if no date
      if (!fields.value.spDatum) {
        fields.value.spVon = null;
        fields.value.spBis = null;
      }

      if (searchForPsycho.value) {
        searchForAerzte.value = false;
      }

      // Update Psycho Altersgruppe according to checked value
      if (!ptaCheck.value && searchForPsycho.value) {
        fields.value.pta = "E";
      } else if (ptaCheck.value && searchForPsycho.value) {
        fields.value.pta = "K";
      } else {
        fields.value.pta = null;
      }
    });

    onUpdated(() => {
      // Pass fach value if in URL
      if (
        (appConf.searchParams.get("ag") || appConf.searchParams.get("loc")) &&
        !preselectLoaded
      ) {
        preselectLoaded = true;
        if (appConf.searchParams.get("ag") == "Psychotherapie") {
          searchForPsycho.value = true;
        }
        setTimeout(() => {
          searchSubmit();
        }, 10);
      }
    });

    return {
      fields,
      geschlechtoptions,
      nowopen,
      clear,
      firstname_hp,
      szLinkOut,
      bfLinkOut,
      searchForPsycho,
      ptaCheck,
      textUnderFormOut,
      ptvoptions,
      ptsoptions,
      preselectFach,
      canSearch,
      loadingForm,
      nowopenChangeHandler,
      updateLoc,
      resetForm,
      searchSubmit,
      selectLoadChange,
      nowopenLabelClick,
      updateCanSearch,
    };
  },
};
</script>

<style >
</style>